import { HOME_BUYING_PROCESS, HOME_BUYING_PROCESS_NARROWING_OPTIONS, HOME_BUYING_PROCESS_CONSIDERING_HOMES, HOME_BUYING_PROCESS_MAKING_OFFER, HOME_BUYING_PROCESS_UNDER_CONTRACT } from '@nerdwallet/home-constants';
import { EMPLOYMENT_FULLTIME, EMPLOYMENT_PARTTIME, EMPLOYMENT_SELF_EMPLOYED, EMPLOYMENT_UNEMPLOYED } from '../data/constants';
export var homeBuyingProcess = {
  name: 'homeBuyingProcess',
  type: 'string',
  whitelist: HOME_BUYING_PROCESS,
  viewConfig: {
    viewType: 'select',
    items: [{
      label: "I'm still researching",
      value: HOME_BUYING_PROCESS_NARROWING_OPTIONS
    }, {
      label: "I'm going to open houses",
      value: HOME_BUYING_PROCESS_CONSIDERING_HOMES
    }, {
      label: "I'm making offers",
      value: HOME_BUYING_PROCESS_MAKING_OFFER
    }, {
      label: "I'm under contract",
      value: HOME_BUYING_PROCESS_UNDER_CONTRACT
    }]
  }
};
export var employmentType = {
  name: 'employmentType',
  type: 'string',
  whitelist: [EMPLOYMENT_FULLTIME, EMPLOYMENT_PARTTIME, EMPLOYMENT_SELF_EMPLOYED, EMPLOYMENT_UNEMPLOYED],
  viewConfig: {
    viewType: 'select',
    items: [{
      label: 'I work full-time',
      value: EMPLOYMENT_FULLTIME
    }, {
      label: 'I work part-time',
      value: EMPLOYMENT_PARTTIME
    }, {
      label: "I'm self-employed",
      value: EMPLOYMENT_SELF_EMPLOYED
    }, {
      label: "I'm unemployed",
      value: EMPLOYMENT_UNEMPLOYED
    }]
  }
};